import styles from "../style";
import { Reveal } from "./reveal";

const Heroserv = () => {
  return (
    <section className={`pt-80 items-center`}>
      <div className={`flex-1 ${styles.flexCenter} flex-col py-20 xl:px-0 sm:px-16 px-6`}>
        <div className="flex flex-col justify-between items-center w-full">
          <Reveal>
            <h1 className="text-center text-tertiary font-semibold xs:text-md text-mm leading-[30px] xs:leading-[50px] xs:max-w-[640px] max-w-[400px]">
              AfriNext Creator Economy Thesis Deep Dive
            </h1>
          </Reveal>
        </div>       
      </div>
      <div className={`flex flex-col gap-2 ${styles.flexCenter}`}>
        <span className="border-r border-1 border-second h-[40px]"></span>
        <p className={`text-ss max-w-[470px] mt-5 text-center text-second`}>
          Scroll Up
        </p>
      </div>
    </section>
  );
};

export default Heroserv;
